import React from "react";
import { SVG } from "../common/SVG";
import TranslatedTextTemp from "./TranslatedTextTemp";
import TranslatedText from "./TranslatedText";
import { SkillCompletedIcon } from "@components/icons/SkillCompleted";

interface CornerSkillCardProps {
  image: string;
  title: string;
  titleNo: number;
  totalCount: number;
  isCompleted?: boolean;
  onClick?: () => void;
}

const CornerSkillCard = ({
  image,
  title,
  titleNo,
  totalCount,
  isCompleted = false,
  onClick,
}: CornerSkillCardProps) => {
  return (
    <div
      className="flex cursor-pointer flex-col items-start justify-start gap-y-1 rounded-br-[20px] rounded-tl-[20px] border border-navy-blue px-4 py-3 dark:text-white"
      onClick={onClick}
    >
      <div className="relative">
        <img
          src={image}
          alt="none"
          width={170}
          height={111}
          className="rounded-[10px]"
        />
        {isCompleted && (
          <div className="absolute -bottom-4 text-white ltr:-right-3 rtl:-left-3 dark:text-black">
            <SkillCompletedIcon width={55} height={55} />
          </div>
        )}
      </div>
      <div
        className={`${
          isCompleted && "max-w-[120px]"
        } h-[42px] text-[14px] font-medium`}
      >
        {title}
      </div>
      <div className="flex items-center justify-start gap-x-1 text-[13px]">
        <div>{totalCount}</div>
        <div>/</div>
        <div>{titleNo}</div>
        <TranslatedText text={`my-skills.skill-card.${"titles"}`} />
      </div>
    </div>
  );
};

export default CornerSkillCard;
